require("babel-polyfill");

import angular from 'angular';
import 'angularjs-slider/dist/rzslider.min';
import 'angularjs-slider/dist/rzslider.min.css';
import 'angular-animate/angular-animate.min';
import Components from './components/components';
import Services from './services/services';
import 'normalize.css';

angular.module('app', [
  'rzModule',
  'ngAnimate',
  Components.name,
  Services.name
]);



// WEBPACK FOOTER //
// ./src/app.js